module.exports = __webpack_public_path__ + "img/tixianhongbao.66f58c1e.png";